
import Web3 from "web3"
import { CURRENT_CHAIN_ID, UseWeb3, useWeb3 } from "./useWeb3"
import lockedstackABI from '../config/abi/lockedstackABI.json'
import contractAddress from '../config/contract'
import BigNumber from "bignumber.js"
import { getWalletAddress } from "../lib/localStorage"
import ERC20 from '../config/abi/ERC20.json'
import { approvelocal } from "../lib/localStorage";


import { EstGas, IsCurrency, IsWrappedCurrency } from './useCommon'


import { consolelog } from "../lib/consolelog"


export const getLockedstackaddress = () => {
    try {
        const CHAINID = CURRENT_CHAIN_ID()
        console.log("chainId-------",CHAINID);
        let Lockedstackaddress = contractAddress.Lockedstacking[`${CHAINID}`]
        console.log("Lockedstackaddress---",Lockedstackaddress);
        return Lockedstackaddress
    } catch (err) {
        consolelog('getNFTpooladdress__err', err, true)
    }
}


export const UsePoolcontract = async (lockAddress) => {
    const web3 = await useWeb3()
    try {
        let contract = new web3.eth.Contract(lockedstackABI, lockAddress)
        return contract
    } catch (err) {
        console.log('UsePoolcontract__err', err, true)
        return false
    }
}

export const Usedetails = async (pid) =>{
    try {
        const pooldetails = await getLockedstackaddress()
        let contract = await UsePoolcontract(pooldetails)
        const account =  await getWalletAddress()
        let poollength = await contract.methods.userInfo(pid,account).call()
        if(poollength){
         return poollength
        }
    
    } catch (error) {
        console.log("Usedetails_err",error);
    }
  

}

export const GetPoolListInfo = async () => {
    try {
        let lockAddress =  getLockedstackaddress()
        let contract = await UsePoolcontract(lockAddress)

       let poollength = await contract.methods.poolLength().call()
       var Lockeddata = []
       console.log("poollength-----",poollength);
       for(let i=0 ;i<poollength;i++){
        let poolInfo = await contract.methods.poolInfo(i).call()
        console.log("poolInfo---",poolInfo,);
        poolInfo = JSON.stringify(poolInfo)
        Lockeddata.push(JSON.parse(poolInfo)) 
        
        
    }
        return Lockeddata
     
    } catch (err) {
        console.log(err, 'GetPoolList__err')
    }
}


// export const updateAPR = async (pid, amount) => {
//     try {
//         const web3 = await useWeb3()
//         console.log("we---3",web3 );
//         const account = await getWalletAddress()
//         const contractAddress =await getLockedstackaddress()

//         let contract = await UsePoolcontract()
//         let params = [pid, amount.toString()]
//         const { gasLimit, gasPrice } = await EstGas(params, lockedstackABI, contractAddress, 'withdraw', account)
//         let result = await contract.methods.updateAPR(pid, amount.toString()).send({ from: web3.utils.toChecksumAddress(account), gasLimit: gasLimit, gasPrice: gasPrice })
//         console.log("result", result)
//         if (result) {
//             // approvelocal(Approve.transactionHash)
//             return true
//         }
//     } catch (err) {
//         console.log("Harvest__err", err, true)
//         return false
//     }
// }

// export const updateAPR = async (pid, amount) => {
//     try {
//       // create a web3 instance (no React hooks)
//       let web3;
//       if (window.ethereum) {
//         web3 = new Web3(window.ethereum);
//         // optional: await window.ethereum.request({ method: 'eth_requestAccounts' });
//       } else if (window.web3) {
//         web3 = new Web3(window.web3.currentProvider);
//       } else {
//         throw new Error("No web3 provider found");
//       }
  
//       console.log("web3 instance:", web3);
  
//       const account = await getWalletAddress();
//       const contractAddress = await getLockedstackaddress();
//       const contract = await UsePoolcontract(); // ensure this creates a web3.eth.Contract
  
//       const params = [pid, amount.toString()];
//       const { gasLimit, gasPrice } = await EstGas(
//         params,
//         lockedstackABI,
//         contractAddress,
//         "deposit",
//         account
//       );
  
//       const result = await contract.methods
//         .updateFixedRate(pid, amount.toString())
//         .send({
//           from: web3.utils.toChecksumAddress(account),
//           gasLimit,
//           gasPrice,
//         });
  
//       console.log("updateAPR result:", result);
//       return true;
//     } catch (err) {
//       console.error("updateAPR error:", err);
//       return false;
//     }
//   };


export const updateAPR = async (pid, amount) => {
    try {
      // create web3 instance
      let web3;
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
      } else if (window.web3) {
        web3 = new Web3(window.web3.currentProvider);
      } else {
        throw new Error("No web3 provider found");
      }
  
      const account = await getWalletAddress();
      if (!account) throw new Error("Wallet not connected");
  
      const contractAddress = await getLockedstackaddress();
      if (!contractAddress) throw new Error("Invalid contract address");
  
      const contract = await UsePoolcontract(contractAddress); // should return web3.eth.Contract
  
      const params = [pid, amount.toString()];
      const gasData = await EstGas(params, lockedstackABI, contractAddress, "updateFixedRate", account);
  
      if (!gasData) throw new Error("Failed to estimate gas");
  
      const result = await contract.methods.updateFixedRate(pid, amount.toString()).send({
        from: web3.utils.toChecksumAddress(account),
        gasLimit: gasData.gasLimit,
        gasPrice: gasData.gasPrice,
      });
  
      console.log("updateAPR result:", result);
      return true;
    } catch (err) {
      console.error("updateAPR error:", err);
      return false;
    }
  };
export const CheckIsApproved = async (Token, amount) => {
    const web3 = await useWeb3()

    try {
        const account = getWalletAddress()
        const spenderAddress = getLockedstackaddress()
        const contract = new web3.eth.Contract(ERC20,Token)
        const allow = await contract.methods?.allowance(account, spenderAddress).call();
        console.log(parseInt(allow) >= amount, parseInt(allow), amount,spenderAddress, 'checkIsApproved')
        return (parseInt(allow) >= amount&&  allow > 0) ? true : false;
    } catch (err) {
        console.log("checkIsApproved_err", err)
    }
}


export const ApproveFarms = async (lpAddress,qureyString) => {
    const web3 = await useWeb3()
    try {
        const spenderAddress = getLockedstackaddress()
        let amount = "115792089237316195423570985008687907853269984665640564039457584007913129639935"
        const account = getWalletAddress()
        let contract = new web3.eth.Contract(ERC20,lpAddress)
        let params = [web3.utils.toChecksumAddress(spenderAddress), amount]
        const { gasLimit, gasPrice } = await EstGas(params, ERC20, lpAddress, 'approve', account)
        let Approve = await contract.methods.approve(web3.utils.toChecksumAddress(spenderAddress), amount).send({ from: web3.utils.toChecksumAddress(account), gasLimit: gasLimit, gasPrice: gasPrice })
        if (Approve) {
            let localdata = {
                qureyString:qureyString,
                txhash:Approve.transactionHash,
            }
            approvelocal(JSON.stringify(localdata))
            return {
                status: true,
                data: Approve
            }
        }
    } catch (err) {
        return false
    }
}


export const Stake = async (amount, pid) => {
    try {
    const web3 = await useWeb3()
    console.log("amount-----",amount,pid);
     const account =  await getWalletAddress()
     const  contractAddressdata   = await getLockedstackaddress()
     console.log("contractAddress--",contractAddressdata);
     let contract = await  UsePoolcontract(contractAddressdata)
     let params = [pid,amount.toString()]
     const { gasLimit, gasPrice } = await EstGas(params, lockedstackABI,contractAddressdata, 'deposit', account)
     let result = await contract.methods.deposit(pid,amount.toString()).send({ from: web3.utils.toChecksumAddress(account), gasLimit: gasLimit, gasPrice: gasPrice })
     if (result) {
        return true
    }

        
    } catch (err) {
        console.log("Stake__err", err, true)
        return false
    }
}

